module.exports = __webpack_public_path__ + "img/out_in_warehouse.31b9d545.png";